import { render, staticRenderFns } from "./AdvertisingSettings.vue?vue&type=template&id=2c7cc32c"
import script from "./AdvertisingSettings.vue?vue&type=script&lang=js"
export * from "./AdvertisingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports